import Handler from "@/core/domain/usecase/handler";

const getServiceOrderByIDReportRepository = (axios) => async (id) => {
    try{
        const response = await axios.get(`service-order/${id}/report`)
        return response.data
    } catch ( err ) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default getServiceOrderByIDReportRepository